import { useEffect } from "react";
import { PageLayout } from "../../Components/PageLayout";
import { useState } from "react";
import instance from "../../Interceptor/api_instance";
import { useTranslation } from "react-i18next";
import { GetVehicleCondition } from "../../Components/Tables/Vehicles/GetVehicleCondition";
import { TablePlaceHolder } from "../../Components/LoadingAnimations/LoadingAnimations";
import PendingTaskEdit from "./Modals/PendingTaskEdit";

const PendingTasksView = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await instance.get(
          "/safety/maintenance-tasks/?status=pending&status=in-progress&status=waiting-parts"
        );
        setData(response.data.results);
      } catch (err) {
        console.error("Error fetching pending tasks:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  return (
    <PageLayout title={"Tasks"} header={"tasks"}>
      {selectedRow && (
        <PendingTaskEdit
          task={selectedRow}
          setData={setData}
          close={() => setSelectedRow(null)}
        />
      )}
      <div className="flex flex-wrap">
        {error && <div className="error">Error: {error}</div>}
        {loading ? (
          <TablePlaceHolder />
        ) : (
          <div className="container">
            <div className="row">
              {data.map((task) => (
                <div
                  key={task.id}
                  className="col-12 col-md-6 mb-3 bg-light"
                  onClick={() => setSelectedRow(task)}
                >
                  <div
                    className="border p-4 rounded shadow h-100 row-hover gray"
                    style={{ textAlign: "center" }}
                  >
                    <h3 className="text-lg font-semibold mb-2 black">
                      {task.maintenance_report.unit}
                    </h3>
                    <p className="">
                      <strong>
                        {t("yard-tables.table-columns.description")}:
                      </strong>{" "}
                      {task.description}
                    </p>
                    <p className="">
                      <strong>
                        {t("yard-tables.table-columns.mechanic")}:
                      </strong>{" "}
                      {task.assigned_mechanic.full_name}
                    </p>
                    <p className="">
                      <strong>
                        {t("yard-tables.table-columns.priority")}:
                      </strong>{" "}
                      <GetVehicleCondition
                        condition={task.maintenance_report.priority}
                      />
                    </p>
                    <p className="">
                      <strong>{t("yard-tables.table-columns.status")}:</strong>{" "}
                      <GetVehicleCondition condition={task.status} />
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </PageLayout>
  );
};

export default PendingTasksView;
